

const Date = props => {
    return (
        <h6 className="date">{props.children}</h6>
    );
}
  
export default Date;
